module.exports = __webpack_public_path__ + "static/media/au.717ae472.svg";